/** Telas modais simples: Menu principal, Pause e Morte. Compartilham o helper de overlay (DRY). */
import { i18n } from "../i18n/i18n";

function makeOverlay(uiRoot: HTMLElement): HTMLDivElement {
  const el = document.createElement("div");
  el.className = "overlay";
  el.hidden = true;
  uiRoot.appendChild(el);
  return el;
}

export class MainMenu {
  private readonly root: HTMLDivElement;
  private readonly titleEl: HTMLElement;
  private readonly sloganEl: HTMLElement;
  private readonly playBtn: HTMLButtonElement;
  private readonly charBtn: HTMLButtonElement;
  private readonly setBtn: HTMLButtonElement;
  private readonly rankBtn: HTMLButtonElement;
  private readonly siteBtn: HTMLButtonElement; // 10.9L1

  constructor(uiRoot: HTMLElement, handlers: { onPlay: () => void; onCharacters: () => void; onSettings: () => void; onRanking: () => void; onSite: () => void }) {
    this.root = makeOverlay(uiRoot);
    this.root.classList.add("main-menu-overlay");
    this.root.innerHTML = `
      <div class="panel">
        <div class="menu-logo"><img src="pwa-192.png" alt="" class="menu-logo-img" /><!-- 10.9FE: mesmo icone do app --></div>
        <h1></h1>
        <div class="slogan"></div>
        <div class="menu-btns">
          <button class="btn primary" data-a="play"></button>
          <button class="btn" data-a="characters"></button>
          <button class="btn" data-a="ranking"></button>
          <button class="btn" data-a="site"></button>
          <button class="btn" data-a="settings"></button>
        </div>
      </div>`;
    this.titleEl = this.root.querySelector("h1")!;
    this.sloganEl = this.root.querySelector(".slogan")!;
    this.playBtn = this.root.querySelector('[data-a="play"]')!;
    this.charBtn = this.root.querySelector('[data-a="characters"]')!;
    this.setBtn = this.root.querySelector('[data-a="settings"]')!;
    this.rankBtn = this.root.querySelector('[data-a="ranking"]')!;
    this.playBtn.onclick = handlers.onPlay;
    this.charBtn.onclick = handlers.onCharacters;
    this.setBtn.onclick = handlers.onSettings;
    this.rankBtn.onclick = handlers.onRanking;
    this.siteBtn = this.root.querySelector('[data-a="site"]')!;
    this.siteBtn.onclick = handlers.onSite; // 10.9L1
    i18n.onChange(() => this.render());
    this.render();
  }

  private render(): void {
    this.titleEl.textContent = i18n.t("game.title");
    this.siteBtn.textContent = "🌐 " + i18n.t("menu.site"); // 10.9L1
    this.sloganEl.textContent = i18n.t("game.slogan");
    this.playBtn.textContent = i18n.t("menu.play");
    this.charBtn.textContent = "🎭 " + i18n.t("class.charsTitle");
    this.setBtn.textContent = i18n.t("menu.settings");
    this.rankBtn.textContent = i18n.t("menu.ranking");
  }

  show(): void { this.root.hidden = false; }
  hide(): void { this.root.hidden = true; }
}

export class PauseMenu {
  private readonly root: HTMLDivElement;
  private readonly titleEl: HTMLElement;
  private readonly resumeBtn: HTMLButtonElement;
  private readonly setBtn: HTMLButtonElement;
  private readonly rankBtn: HTMLButtonElement;
  private readonly charBtn: HTMLButtonElement; // 10.9CY
  private readonly grimBtn: HTMLButtonElement; // 10.9FC
  private readonly idxBtn: HTMLButtonElement; // 10.9GA
  private readonly howBtn: HTMLButtonElement; // 10.9IH
  private readonly siteBtn: HTMLButtonElement; // 10.9L1

  constructor(
    uiRoot: HTMLElement,
    handlers: { onResume: () => void; onSettings: () => void; onRanking: () => void; onCharacters: () => void; onGrimoire: () => void; onIndex: () => void; onHowTo: () => void; onSite: () => void },
  ) {
    this.root = makeOverlay(uiRoot);
    this.root.classList.add("pause-menu-overlay");
    // 10.8E — REMOVIDO o botão "Reiniciar": num jogo de progressão ele confunde/assusta.
    // 10.8F — ADICIONADO "Ranking". Sobra Continuar + Ranking + Configurações.
    this.root.innerHTML = `
      <div class="panel">
        <h2></h2>
        <div class="menu-btns">
          <button class="btn primary" data-a="resume"></button>
          <button class="btn" data-a="howto"></button>
          <button class="btn" data-a="grimoire"></button>
          <button class="btn" data-a="index"></button>
          <button class="btn" data-a="characters"></button>
          <button class="btn" data-a="ranking"></button>
          <button class="btn" data-a="site"></button>
          <button class="btn" data-a="settings"></button>
        </div>
      </div>`;
    this.titleEl = this.root.querySelector("h2")!;
    this.resumeBtn = this.root.querySelector('[data-a="resume"]')!;
    this.setBtn = this.root.querySelector('[data-a="settings"]')!;
    this.rankBtn = this.root.querySelector('[data-a="ranking"]')!;
    this.charBtn = this.root.querySelector('[data-a="characters"]')!; // 10.9CY
    this.resumeBtn.onclick = handlers.onResume;
    this.setBtn.onclick = handlers.onSettings;
    this.rankBtn.onclick = handlers.onRanking;
    this.charBtn.onclick = handlers.onCharacters; // 10.9CY
    this.grimBtn = this.root.querySelector('[data-a="grimoire"]')!;
    this.grimBtn.onclick = handlers.onGrimoire; // 10.9FC
    this.idxBtn = this.root.querySelector('[data-a="index"]')!;
    this.idxBtn.onclick = handlers.onIndex; // 10.9GA
    this.howBtn = this.root.querySelector('[data-a="howto"]')!;
    this.howBtn.onclick = handlers.onHowTo; // 10.9IH
    this.siteBtn = this.root.querySelector('[data-a="site"]')!;
    this.siteBtn.onclick = handlers.onSite; // 10.9L1
    i18n.onChange(() => this.render());
    this.render();
  }

  private render(): void {
    this.titleEl.textContent = i18n.t("game.paused");
    this.resumeBtn.textContent = i18n.t("menu.resume");
    this.charBtn.textContent = "🎭 " + i18n.t("class.charsTitle"); // 10.9CY/DM
    this.grimBtn.textContent = "📖 " + i18n.t("grim.title"); // 10.9FC
    this.idxBtn.textContent = "📕 " + i18n.t("index.title"); // 10.9GA
    this.howBtn.textContent = "❓ " + i18n.t("htp.title"); // 10.9IH
    this.siteBtn.textContent = "🌐 " + i18n.t("menu.site"); // 10.9L1
    this.setBtn.textContent = i18n.t("menu.settings");
    this.rankBtn.textContent = i18n.t("menu.ranking");
  }

  show(): void { this.root.hidden = false; }
  hide(): void { this.root.hidden = true; }
}

export class DeathScreen {
  private readonly root: HTMLDivElement;
  private readonly titleEl: HTMLElement;
  private readonly subEl: HTMLElement;
  private seconds = 0;

  private readonly reviveBtn: HTMLButtonElement;
  private readonly blessBtn: HTMLButtonElement;
  private reviveLeft = 0;
  private reviveVip = false;
  private blessCount = 0;

  constructor(uiRoot: HTMLElement, private readonly onRevive?: () => void, private readonly onBlessRevive?: () => void) {
    this.root = makeOverlay(uiRoot);
    // 10.9BE — "Reviver aqui" (anúncio recompensado; VIP sem vídeo)
    // 10.9K4 — + "Reviver com Bênção" (sem anúncio, gasta 1 Bênção)
    this.root.innerHTML = `<div class="panel death"><h2></h2><div class="sub"></div><button class="btn primary death-revive" hidden></button><button class="btn death-bless" hidden></button><div class="death-revive-note"></div></div>`;
    this.titleEl = this.root.querySelector("h2")!;
    this.subEl = this.root.querySelector(".sub")!;
    this.reviveBtn = this.root.querySelector(".death-revive")!;
    this.reviveBtn.addEventListener("click", () => this.onRevive?.());
    this.blessBtn = this.root.querySelector(".death-bless")!;
    this.blessBtn.addEventListener("click", () => this.onBlessRevive?.());
    i18n.onChange(() => this.render());
  }

  /** 10.9K4 — Bênçãos em estoque (0 = esconde o botão). VIP já revive sem anúncio: não oferece. */
  setBless(n: number): void {
    this.blessCount = n;
    this.render();
  }

  setCountdown(seconds: number): void {
    this.seconds = seconds;
    this.render();
  }

  /** 10.9BE — quantas revives por anúncio restam hoje (0 = esconde o botão). */
  setRevive(left: number, vip: boolean): void {
    this.reviveLeft = left;
    this.reviveVip = vip;
    this.render();
  }

  private render(): void {
    this.titleEl.textContent = i18n.t("game.youDied");
    this.subEl.textContent = i18n.t("game.respawning", { s: Math.ceil(this.seconds) });
    this.reviveBtn.hidden = this.reviveLeft <= 0;
    this.reviveBtn.textContent = this.reviveVip ? i18n.t("ads.reviveVip") : i18n.t("ads.revive");
    this.blessBtn.hidden = this.blessCount <= 0 || this.reviveVip;
    this.blessBtn.textContent = i18n.t("bless.revive", { n: this.blessCount });
    // 10.9K4 — revive por anúncio é ILIMITADO (Ads.left devolve 99): "Restam 99 hoje" confundia
    this.root.querySelector(".death-revive-note")!.textContent = this.reviveLeft > 0 && this.reviveLeft < 99 ? i18n.t("ads.reviveNote", { n: this.reviveLeft }) : "";
  }

  show(): void { this.root.hidden = false; }
  hide(): void { this.root.hidden = true; }
}
